module.exports = __webpack_public_path__ + "img/AD.e0c6a498.svg";